export default __webpack_public_path__ + "static/media/frog-face.9d1f1c9a.jpeg";